/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap"
import BaseCom from "../BaseCom"
import { qreq } from "../../shared/qrequest";

export default class AboutModal extends BaseCom {
    async componentDidMount() {
        await this.pullVersion();
    }

    pullVersion = async () => {
        try {
            let j = await qreq.getAsync('/api/version');
            this.setState({ version: j.item });
        }
        catch (e) {
            console.error(e);
        }
    }

    getPoweredBy = () => {
        if (this.props.org.ident === 'taplocal')
            return <strong><a href="http://taplocalnow.com" target="_blank" rel="noopener noreferrer">TapLocal Now</a></strong>;
        else if (this.props.org.ident === 'banktech')
            return <strong><a href="https://banktechpr.com" target="_blank" rel="noopener noreferrer">BankTech PR</a></strong>;
        else
            return <strong>{this.props.org.name}</strong>;
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>About Web Builder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>A web-based tool for creating and editing websites.</p>
                {this.props.org && <p>Powered by: {this.getPoweredBy()}.</p>}
                <p>Created by: <strong><a href="https://solusek.com" target="_blank" rel="noopener noreferrer">Solusek Systems</a></strong></p>
                <div className="d-flex justify-content-between">
                    <div>Release: v{this.state.version}</div>
                    <div className="text-muted">Web Builder</div>
                </div>
            </Modal.Body>
        </Modal>;
    }
}